// @ts-nocheck
import { AUTH_USER_FETCHING, AUTH_USER_LOGGED_IN, AUTH_USER_LOGGED_OUT, SET_LOGIN_FORM_CHANGED } from '../types';

const initialState = {
    isAuthenticated: false,
    isFetching: true,
    user: {},
    tempLoginData: null,
};

const auth = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case AUTH_USER_LOGGED_IN: {
            return {
                ...state,
                isAuthenticated: true,
                isFetching: false,
                user: payload,
            };
        }
        case AUTH_USER_LOGGED_OUT: {
            return {
                ...state,
                isAuthenticated: false,
                user: {},
            };
        }
        case AUTH_USER_FETCHING: {
            return {
                ...state,
                isFetching: payload,
            };
        }
        // case AUTH_USER_PERMISSIONS_CHANGED: {
        //     return {
        //         ...state,
        //         permissions: payload,
        //     };
        // }
        case SET_LOGIN_FORM_CHANGED: {
            return {
                ...state,
                tempLoginData: payload,
            };
        }
        default:
            return state;
    }
};

export default auth;
